import React from 'react';
import { connect } from 'react-redux';
import { configSelector } from '~/common/selectors/config';

/**
 * HOC to inject configuration from redux-state into components.
 */
export default WrappedComponent => {
  const WithConfigComponent = props => <WrappedComponent {...props} />;

  const mapStateToProps = state => ({
    config: configSelector(state),
  });

  return connect(mapStateToProps)(WithConfigComponent);
};



// WEBPACK FOOTER //
// ./app/hoc/WithConfig.js